module.exports = __webpack_public_path__ + "static/media/Zendy-logo.a5571539.png";